<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
        <el-button no="exportExcel" type="primary" @click="exportExcel">{{ $t('common.btn.exportExcel') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101309"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.cargoType.code')">
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.cargoType.chineseName')">
            <el-input v-model="editDialog.form.chineseName" no="chineseName" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.cargoType.englishName')">
            <el-input v-model="editDialog.form.englishName" no="englishName" />
          </el-form-item>
          <el-form-item :label="' '">
            <el-checkbox v-model="editDialog.form.sea" no="sea">{{ $t('baseInfo.basicData.cargoType.sea') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.air" no="air">{{ $t('baseInfo.basicData.cargoType.air') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.fbaSea" no="fbaSea">{{ $t('baseInfo.basicData.cargoType.fbaSea') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.fbaAir" no="fbaAir">{{ $t('baseInfo.basicData.cargoType.fbaAir') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.fbaRailway" no="fbaRailway">{{ $t('baseInfo.basicData.cargoType.fbaRailway') }}</el-checkbox>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="display: flex;">
              <el-tooltip :content="$t('CargoMsg.Cargo_ShowCharacteristicsTip')" placement="right">
                <i class="el-icon-question" style="cursor: pointer;color: #1F75D5;" />
              </el-tooltip>
              {{ $t('CargoMsg.Cargo_ShowCharacteristics') }}
            </span>
            <el-checkbox v-model="editDialog.form.showCharacteristics" no="showCharacteristics" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCargoTypeList, saveCargoType, delCargoType, dragCargoType } from '@/api/basicData/cargoType'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'CargoType',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDragEnd: this.onRowDragEnd, // 拖动结束
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DisplayOrder'),
          rowDrag: true,
          width: 120,
          sortable: false,
          suppressMenu: true,
          sortable: false,
          suppressSizeToFit: true
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.code'),
          field: 'code',
          width: 100,
          sortable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.chineseName'),
          field: 'chineseName',
          width: 200,
          sortable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.englishName'),
          field: 'englishName',
          width: 200,
          sortable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.sea'),
          field: 'seaStr',
          width: 100,
          sortable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.air'),
          field: 'airStr',
          width: 100,
          sortable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.fbaSea'),
          field: 'fbaSeaStr',
          width: 100,
          sortable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.fbaAir'),
          field: 'fbaAirStr',
          width: 100,
          sortable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.cargoType.fbaRailway'),
          field: 'fbaRailwayStr',
          width: 100,
          sortable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ShowCharacteristics'),
          field: 'showCharacteristicStr',
          width: 100,
          sortable: false
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: '',
          chineseName: '',
          englishName: '',
          serialNumber: 0,
          sea: false,
          air: false,
          fbaSea: false,
          fbaAir: false,
          fbaRailway: false,
          showCharacteristics: false
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    onRowDragEnd(event) {
      const { overNode } = event
      const overData = overNode.data
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const loading = getLoading4Cxt(this)
      dragCargoType({
        dragTargetUuid: overData.uuid,
        dragTargetPreUuid: nodes[event.overIndex - 1] ? nodes[event.overIndex - 1].data.uuid : '',
        dragTargetNextUuid: nodes[event.overIndex + 1] ? nodes[event.overIndex + 1].data.uuid : ''
      }).then(res => {
        this.toQuery()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        syncSpecificBasicData(basicCacheKeys.basic_data_CargoType)
      }).finally(() => {
        loading.close()
      })
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getCargoTypeList(self.filter).then(res => {
        res.data.list.forEach(item => {
          item.seaStr = item.sea ? 'Y' : ''
          item.airStr = item.air ? 'Y' : ''
          item.fbaSeaStr = item.fbaSea ? 'Y' : ''
          item.fbaAirStr = item.fbaAir ? 'Y' : ''
          item.fbaRailwayStr = item.fbaRailway ? 'Y' : ''
          item.showCharacteristicStr = item.showCharacteristics ? 'Y' : ''
        })
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          code: '',
          chineseName: '',
          englishName: '',
          serialNumber: 0,
          sea: false,
          air: false,
          fbaSea: false,
          fbaAir: false,
          fbaRailway: false,
          showCharacteristics: false
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_CargoType')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_CargoType')
      }
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.cargoType.codeCheck'))
        return
      }
      if (!form.chineseName) {
        self.$message.warning(self.$t('baseInfo.basicData.cargoType.chineseNameCheck'))
        return
      }
      saveCargoType(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => { })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delCargoType(rows[index].uuid).then(res => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.toQuery()
        self.$message.success(self.$t('common.tips.deleteSuccess'))
      }
    },
    exportExcel() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          self.$t('baseInfo.basicData.cargoType.code'),
          self.$t('baseInfo.basicData.cargoType.chineseName'),
          self.$t('baseInfo.basicData.cargoType.englishName'),
          self.$t('baseInfo.basicData.cargoType.sea'),
          self.$t('baseInfo.basicData.cargoType.air')
        ]
        const filterVal = ['code', 'chineseName', 'englishName', 'seaStr', 'airStr']
        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'CargoType'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>

<style>
</style>
